import { render, staticRenderFns } from "./CopyAPISecretDialog.vue?vue&type=template&id=dc5b046a&scoped=true"
import script from "./CopyAPISecretDialog.vue?vue&type=script&lang=ts"
export * from "./CopyAPISecretDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5b046a",
  null
  
)

export default component.exports